import { createContext, useContext, useState, useCallback } from "react";

const IntakeContext = createContext(null);

export const useIntake = () => useContext(IntakeContext);

export const IntakeProvider = ({ children }) => {
  const [state, setState] = useState({ isOpen: false, plan: "letter" });

  const open = useCallback((plan = "letter") => {
    setState({ isOpen: true, plan });
  }, []);

  const close = useCallback(() => {
    setState((s) => ({ ...s, isOpen: false }));
  }, []);

  return (
    <IntakeContext.Provider value={{ ...state, open, close }}>
      {children}
    </IntakeContext.Provider>
  );
};
